<!--
 * @Author: pluto.guo 66291979@qq.com
 * @Date: 2024-12-11 15:34:08
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-03-03 15:47:51
 * @FilePath: /lobby/src/components/deposit/SelectDepositAmountComponent.vue
 * @Description: 选择充值金额组件
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="amount-content">
    <div class="head-name">Choose an amount</div>
    <div style="width: 100%">
      <div class="choose_amount">
        <div
          :class="select.id == item.id ? 'amount_active' : ''"
          v-for="(item, index) in recommentConfig"
          :key="index"
          @click="onSelectAmount(item)"
        >
          <!-- <li>
            <i v-if="item.hot">{{ $t('deposit.hot') }}</i>
            <h2 :style="`margin: ${item.hot ? 0.13 : 0.22}rem 0`">
              {{ formatMoney(item.amount) }}
            </h2>
          </li> -->
          <li>
            <i v-if="item.hot">{{ $t('deposit.hot') }}</i>
            <h2
              :style="`margin: ${getBonusByAmount(item.amount) > 0 ? (item.hot ? -0.1 : 0.12) : item.hot ? 0 : 0.27}rem 0`"
            >
              {{ formatMoney(item.amount) }}
            </h2>
            <div
              v-if="getBonusByAmount(item.amount) > 0"
              class="gift-bonus"
              :style="select.id == item.id ? 'background:#CEB45F' : ''"
            >
              <span class="bonus">Gift {{ getBonusByAmount(item.amount) }} Bonus</span>
            </div>
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useDepositStore } from '@/stores/deposit'
import { formatMoney } from '@/utils/helper'
import { mapActions } from 'pinia'

/**
 * 导入必要的模块或组件
 */

export default {
  props: {
    inputAmount: {
      type: String,
      default: ''
    },
    rechargeConfig: {
      type: Array
    }
  },
  /**
   * 定义组件的数据
   * @returns {Object} 返回一个对象，包含组件的数据
   */
  data() {
    return {
      recommentConfig: [],
      select: {}
    }
  },
  /**
   * 定义组件的方法
   * @returns {Object} 返回一个对象，包含组件的方法
   */
  methods: {
    formatMoney,
    ...mapActions(useDepositStore, ['requestConfig']),
    onSelectAmount(item) {
      console.log('onSelectAmount', item)
      this.select = item
      this.$emit('select', item)
    },
    getBonusByAmount(amount) {
      const maximumReward = this.rechargeConfig.maximumReward
      const rewardPercent = this.rechargeConfig.rewardPercent
      return Math.min(maximumReward, Math.round(amount * rewardPercent) / 100)
    }
  },
  /**
   * 定义组件的生命周期钩子
   * @returns {Object} 返回一个对象，包含组件的生命周期钩子
   */
  mounted() {
    this.requestConfig().then((response) => {
      console.log('deposit.config: =>>', response)
      this.recommentConfig = response.Configs
      //默认选中第三个,如果没有输入值,默认选中第三个
      if (this.inputAmount == '') {
        this.onSelectAmount(this.recommentConfig[2])
      } else {
        const find = this.recommentConfig.find(
          (item) => Number(item.amount) == Number(this.inputAmount)
        )
        this.select = find || {}
      }
    })
  },
  /**
   * 定义组件的计算属性
   * @returns {Object} 返回一个对象，包含组件的计算属性
   */
  computed: {
    // 在这里定义组件的计算属性
  },
  /**
   * 定义组件的监听器
   * @returns {Object} 返回一个对象，包含组件的监听器
   */
  watch: {
    // 在这里定义组件的监听器
    inputAmount(val) {
      const find = this.recommentConfig.find((item) => Number(item.amount) == Number(val))
      this.select = find || {}
      if (this.select.id) {
        this.$emit('select', this.select)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.amount-content {
  width: 100%;
  height: auto;
  padding: 0;

  .head-name {
    font-size: 0.24rem;
    color: #000000;
    margin-left: 0.1rem;
    margin-top: 0.1rem;
  }

  .choose_amount {
    margin-top: 0.1rem;
    height: auto;
    width: 100%;
    overflow: hidden;

    .amount_active li {
      background-color: #ceb45f;
      border-top-width: 1px;
      border-right-width: 1px;
      border-bottom-width: 2px;
      border-left-width: 1px;
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
      border-top-color: #aa884a;
      border-right-color: #aa884a;
      border-bottom-color: #aa884a;
      border-left-color: #aa884a;
    }

    .amount_active li h2,
    .amount_active li {
      color: #fff;
    }

    li {
      margin: 2.5%;
      float: left;
      width: 1.73rem;
      height: 1.1rem;
      border-radius: 0.08rem;
      background-color: #fff;
      display: inline-block;
      border-top-width: 1px;
      border-right-width: 1px;
      border-bottom-width: 2px;
      border-left-width: 1px;
      border-top-style: solid;
      border-right-style: solid;
      border-bottom-style: solid;
      border-left-style: solid;
      border-top-color: #ceb45f;
      border-right-color: #ceb45f;
      border-bottom-color: #ceb45f;
      border-left-color: #ceb45f;
      text-align: center;
      overflow: hidden;

      i {
        font-size: 0.14rem;
        font-style: normal;
        color: #fff;
        background-color: #e84c3d;
        width: 0.8rem;
        float: right;
        margin: -0.18rem -0.32rem 0 0;
        padding: 0.29rem 0 0 0;
        display: block;
        position: relative;
        -moz-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        text-align: center;
        z-index: 2;
      }

      h2 {
        font-family: Oswald_Bold;
        text-align: center;
        font-size: 0.36rem;
        color: #ceb45f;
        width: 100%;
        float: left;
        padding: 0px;
        margin: -0.08rem 0 0.05rem 0;
        position: relative;
      }

      .gift-bonus {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        width: 1.68rem;
        height: 0.4rem;
        background: #e84c3d;
        border-radius: 0rem 0rem 0.08rem 0.08rem;
        color: #fff;
        margin-top: 0.68rem;
        margin-left: 0.04rem;
        overflow: hidden;
        .bonus {
          width: 1.68rem;
          height: 0.21rem;
          font-family: Oswald;
          font-weight: 400;
          font-size: 0.21rem;
          color: #ffffff;
          line-height: 0.21rem;
          text-align: center;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
